export default "__VITE_ASSET__BHtV3j9c__"